import { observable, action, computed, toJS } from 'mobx'
import http from '../../services/httpServiceEver'
import { getRole } from '../../constant'

const apiEndpoint = '/kycPatientImages'

const FIREBASE_STORAGE_OLD_HOST = 'vajira-smart-hospital.appspot.com'
const FIREBASE_STORAGE_NEW_HOST = 'telemed-prod-408808.appspot.com'

function rewriteKycImageUrls(row) {
  if (!row || typeof row !== 'object') return row
  const next = { ...row }
  if (typeof next.image === 'string') {
    next.image = next.image.replace(FIREBASE_STORAGE_OLD_HOST, FIREBASE_STORAGE_NEW_HOST)
  }
  if (typeof next.cIdImage === 'string') {
    next.cIdImage = next.cIdImage.replace(FIREBASE_STORAGE_OLD_HOST, FIREBASE_STORAGE_NEW_HOST)
  }
  return next
}

class KycPatientImage {
  @observable info = {
    data: [],
    error: null
  }

  @action fetchPatientImage = async patientId => {
    try {
      const { data } = await http.get(`${apiEndpoint}/filterByPatientId?patientId=${patientId}`)
      console.log('data', data);
      return rewriteKycImageUrls(data[0])
    } catch (error) {
      console.warn(error)
    }
  }

  @computed get getKycPatientImage() {
    return toJS(this.logistic.data)
  }
}

export default new KycPatientImage()
